module.exports = __webpack_public_path__ + "img/afif.e495aa67.jpg";